export const workflowSteps = [
  { id: "categories", label: "Categories" },
  { id: "type-of-places", label: "Type of places" },
  { id: "type-of-service", label: "Type of Service" },
  { id: "areas", label: "Areas" },
  { id: "objects", label: "Extra Objects" },
  { id: "special-requests", label: "Special Requests" },
];

/** When includeSpecialRequests is false, the step is omitted from the stepper (no catalog items). */
export const buildWorkflowSteps = (includeSpecialRequests) =>
  includeSpecialRequests ? workflowSteps : workflowSteps.filter((s) => s.id !== "special-requests");
